export default {
  methods: {
    async getInvestorIdentity(iid){
      try {
        const res = await axios.get(`api/v2/investor/${iid}/getInvestorIdentityInfo`);
        return res.data.identity;
      }
      catch (e) {
        return null;
      }
    },
    async getInvestorIdentityStatus(iid){
      let identity = await this.getInvestorIdentity(iid);
      let status = 0;
      if(identity !== null){
        this.status = 0;
        status = identity.identity_status;
      }
      return status;
    },
    shouldRunMatiProcess(status){
      return status === 0 || status === 4 || status === 5 || status === null;
    },
    matiIsPending(status){
      return status === 0 || status === null;
    },
    matiIsRunning(status){
      return status === 3 || status === 2;
    },
    verificationIsCompleted(status){
      return status === 1;
    },
    verificationIsRejected(status){
      return status === 4;
    },
    verificationIsInProcess(status){
      return status === 3;
    },
    verificationisNewRequired(status){
      return status === 5;
    },
    verificationIsReviewNeeded(status){
      return status === 2;
    },
  }
}